<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-popup tm-info-frame">
    <v-row class="com-popup-header">
      <span v-if="showInformation" class="com-popup-title"
        >{{ text.infoTitle }}
      </span>
      <span v-if="showRiverWarnInfo" class="com-popup-title"
        >{{ text.rwInfoTitle }}
      </span>
      <v-spacer></v-spacer>
      <v-btn x-small icon color="white" @click="closeInfo">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-row>
    <v-col class="com-popup-contents tm-info-frame-content">
      <v-col class="com-popup-contents-scroll content-scroll pa-0">
        <map-info v-if="showInformation"></map-info>
        <map-river-warn-info v-if="showRiverWarnInfo"></map-river-warn-info>
      </v-col>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用お知らせ・河川予警報一覧フレーム
 * TmInfoFrame.vue
 * @author LIS
 */
import MapInfo from "./MapInfo.vue";
import MapRiverWarnInfo from "./MapRiverWarnInfo.vue";

export default {
  /** タグ名 */
  name: "map-tm-info-frame",
  components: { MapInfo, MapRiverWarnInfo },
  data() {
    return {
      /** 文字列リソース */
      text: {
        infoTitle: "お知らせ",
        rwInfoTitle: "発表情報一覧",
      },
    };
  },
  computed: {
    /** お知らせの表示/非表示 */
    showInformation: {
      get() {
        return this.$store.state.map.showInformation;
      },
    },
    /** 河川予警報一覧の表示/非表示 */
    showRiverWarnInfo: {
      get() {
        return this.$store.state.map.showRiverWarnInfo;
      },
    },
  },
  /** メソッド */
  methods: {
    /** お知らせ情報を閉じる */
    closeInfo() {
      this.$store.commit("map/hideInfoRw");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "../../scss/kwb.scss";

.tm-info-frame {
  width: 50%;
  max-width: 400px;
  top: 4px;
  right: 4px;
  z-index: 3070;
  position: absolute;
  .tm-info-frame-content {
    height: 100%;
    .content-scroll {
      position: static;
      // (画面全体の高さ - ヘッダーの高さ) * 0.6(=60%) - (ダイアログヘッダーの高さ + ダイアログcontentsの余白)
      max-height: calc(((100vh - 88px) * 0.6) - (24px + 24px));
    }
  }
}
</style>
